
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.148 1.86a2.89 2.89 0 00-3-.71L1.998 5.88a2.9 2.9 0 00-.12 5.47l5.24 2a.93.93 0 01.53.52l2 5.25a2.87 2.87 0 002.71 1.88h.07a2.88 2.88 0 002.69-2l4.73-14.17a2.89 2.89 0 00-.7-2.97zm-1.15 2.34l-4.78 14.18a.88.88 0 01-.84.62.92.92 0 01-.87-.58l-2-5.25a2.91 2.91 0 00-1.67-1.68l-5.25-2a.9.9 0 01-.59-.87.88.88 0 01.62-.84l14.18-4.73a.91.91 0 011.2 1.15z","fill":"#1B4332"}})])
          )
        }
      }
    